import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { Grid } from '@mui/material';
import clsx from 'clsx';

import { LOOK, TotalSumInput } from 'components/_basic/TotalSumInput';
import { PROFITABILITY_FORM_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/FinancialPerformance/ProfitabilityForm/utils/form';
import { profitabilityFormPrefix } from 'components/BusinessToolForm/Sections/FinancialPlan/FinancialPerformance/utils/form';

import { concatWithDot } from 'helpers/string';

import { IFieldTableTotalRowProps } from './types';

import styles from './FieldTableTotalRow.module.scss';

export const FieldTableTotalRow: React.FC<IFieldTableTotalRowProps> = memo(
  ({ totalName, columns, disabled, firstColumnWidth, totalRowTitle, titleColumnGap = 2, titleStyles }) => {
    const { t } = useTranslation();

    // it is needed to remove total row styles for Net Profit row in 'Profitability ratios' table only
    const removeTotalRowStyles =
      totalName === concatWithDot(profitabilityFormPrefix, PROFITABILITY_FORM_NAMES.PROFITABILITY_TOTAL);

    return (
      <Grid container sx={{ marginBottom: '8px', boxSizing: 'border-box' }} wrap="nowrap" gap={titleColumnGap}>
        <Grid
          item
          sx={{ width: firstColumnWidth, minWidth: firstColumnWidth }}
          className={clsx(
            styles.summaryTitle,
            titleStyles,
            { [styles.disabled]: disabled },
            { [styles.ordinaryTitle]: removeTotalRowStyles },
          )}
        >
          {totalRowTitle ? totalRowTitle : t('total')}
        </Grid>
        <Grid item xs>
          <Grid container spacing={1} columns={columns.length} wrap="nowrap">
            {columns.map((item) => {
              const name = concatWithDot(totalName, item);
              return (
                <Grid key={item} item xs={1}>
                  <TotalSumInput
                    name={name}
                    disabled={disabled}
                    look={LOOK.SUCCESS}
                    className={clsx(styles.totalSumInput, { [styles.ordinaryInput]: removeTotalRowStyles })}
                    decimalScale={1}
                  />
                </Grid>
              );
            })}
          </Grid>
        </Grid>
      </Grid>
    );
  },
);
